import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <div className="relative">
        <span className="font-heading text-[7rem] md:text-[10rem] font-bold text-background-200 leading-none select-none">
          404
        </span>
      </div>
      <h1 className="mt-2 text-xl md:text-2xl font-heading font-semibold text-foreground-950">
        页面走丢啦
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md">
        你访问的页面不存在或已被移动，不妨回到首页继续浏览舒淇的影视作品与最新动态。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:border-accent-400 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-film-line" />
          浏览影视作品
        </Link>
      </div>
    </div>
  );
}